import styled from 'styled-components';

export const GroupsGridStyled = styled.div`
  width: 100%;
  margin-top: 20px;
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
`;
